import axios from 'axios';
import { baseUrl } from '../Infrastructure/Config/ApiConfig';
import { token } from './AuthService';

const controllerName = 'Account';

export const createNewClientAsync = async (data) => {
    const response = await axios.post(`${baseUrl()}${controllerName}/CreateClient`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const clientCreateUserAsync = async (data, role) => {
    const response = await axios.post(`${baseUrl()}${controllerName}/Create${role}`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });

    return response.data;
}

export const getMyAccountAsync = async () => {
    const response = await axios.get(`${baseUrl()}${controllerName}/MyAccount`, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const updateAccountAsync = async (data) => {
    const response = await axios.post(`${baseUrl()}${controllerName}/UpdateAccount`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const confirmAccountGetAsync = async (userId) => {
    const response = await axios.get(`${baseUrl()}${controllerName}/ConfirmAccount/${userId}`);
    return response.data;
}

export const confirmAccountAsync = async (data) => {
    const response = await axios.post(`${baseUrl()}${controllerName}/ConfirmAccount`, data);
    return response.data;
}

export const confirmLearnerAccountAsync = async (data) => {
    const response = await axios.post(`${baseUrl()}${controllerName}/ConfirmLearnerAccount`, data);
    return response.data;
}

export const resendActivationEmailAsync = async data => {
    const response = await axios.post(`${baseUrl()}${controllerName}/ResendActivationEmail`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const getAccountRegisterDetailsAsync = async () => {
    const response = await axios.get(`${baseUrl()}${controllerName}/GetAccountRegisterDetails`);
    return response.data;
}

// Create Learner - Enhanced
export const createLearnerAsync = async (data) => {
    const response = await axios.post(`${baseUrl()}${controllerName}/CreateLearner`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

// Create Client Admin - Enhanced
export const createClientAdminAsync = async (data) => {
    const response = await axios.post(`${baseUrl()}${controllerName}/CreateClientAdmin`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

// Bulk Create Learners - Platform Admins Only
export const bulkCreateLearnersAsync = async (data) => {
    const response = await axios.post(`${baseUrl()}${controllerName}/BulkCreateLearners`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`
        }
    });
    return response.data;
}

export const sendReminderAsync = async (data) => {
    const response = await axios.post(`${baseUrl()}${controllerName}/SendReminder`, data, {
        headers: {
            'Authorization': `Bearer ${token()}`,
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}
